import { KeyMap, KIO, KK, OutputMode, Record, VirtualHe6Ultra, VK } from "@hid/define/define"
import { DeviceMapKey } from "./device"
import { defaultVK } from "@hid/define/define_keys"
import { DeviceDVKFromKK, DVKFromVK, HIDFromVk } from "@hid/define/define_fn";
import defineType from "@hid/define/define_type";



class he6Ultra implements DeviceMapKey {
    encodeKey(_params: KIO): KeyMap {
        return [0, 0, 0, 0]
    }

    encodeKeyAdapter(params: KIO): number[][] {

        if (params.Output.Mode == OutputMode.Key && params.Output.VK == defaultVK) {
            const dvk = DeviceDVKFromKK(params.Input.KK, VirtualHe6Ultra)
            const [setMode, setVK] = this.splitDVK(dvk);
            const addr = CompxEepromAddr.KeyFunction + params.Input.KK * 4;
            const data = [setMode, setVK >> 8, setVK & 0xFF];
            data[data.length] = this.getCrc(data) & 0xff;
            return [[addr, ...data]]
        }

        if (params.Output.Mode == OutputMode.Fire) {
            const addr = CompxEepromAddr.KeyFunction + params.Input.KK * 4;
            const data = [CompxMouseKeyFunction.FireKey, params.Output.Extension[1], params.Output.Extension[0], 0]
            data[data.length - 1] = this.getCrc(data) & 0xff;
            return [[addr, ...data]]
        }

        let setMode = 0;
        let setVK = 0;
        if (defineType.isMedia(params.Output.VK) || defineType.isMouse(params.Output.VK)) {
            const dvk = DVKFromVK(params.Output.VK, VirtualHe6Ultra);
            [setMode, setVK] = this.splitDVK(dvk);
        } else {
            setMode = CompxMouseKeyFunction.ShortcutKey;
            const hid = HIDFromVk(params.Output.VK)
            if (hid == undefined) {
                throw new Error("hid not found:" + params.Output.VK);
            }
            setVK = hid
        }

        if (setMode == CompxMouseKeyFunction.MouseKey || setMode == CompxMouseKeyFunction.DPISwitch) {
            const addr = CompxEepromAddr.KeyFunction + params.Input.KK * 4;
            const data = [setMode, setVK >> 8, setVK & 0xFF];
            data[data.length] = this.getCrc(data) & 0xff;
            return [[addr, ...data]]
        }

        if (setMode == CompxMouseKeyFunction.ShortcutKey) {
            return this.shortcutKey(params);
        }

        if (setMode == CompxMouseKeyFunction.Media) {
            const addr = CompxEepromAddr.ShortcutKey + params.Input.KK * 0x20;
            const data = [0x02, 0x82, setVK & 0xFF, setVK >> 8, 0x42, setVK & 0xFF, setVK >> 8, 0];
            data[data.length - 1] = this.getCrc(data) & 0xff;

            const keyAddr = CompxEepromAddr.KeyFunction + params.Input.KK * 4;
            const keyData = [CompxMouseKeyFunction.ShortcutKey, 0, 0];
            keyData[keyData.length] = this.getCrc(keyData) & 0xff;

            return [[addr, ...data], [keyAddr, ...keyData]]
        }

        return []
    }

    private shortcutKey(params: KIO) {
        const addr = CompxEepromAddr.ShortcutKey + params.Input.KK * 0x20;
        const shortCut = [params.Output.VK, ...params.Input.WithModifier];

        const value = [];
        let cnt = shortCut.length;
        value.push(cnt * 2);


        params.Input.WithModifier.forEach((vk) => {
            const dvk = DVKFromVK(vk, VirtualHe6Ultra);
            value.push(0 | 0x80);
            value.push(dvk & 0xFF);
            value.push((dvk >> 8) & 0xFF);
        })
        var tmp = HIDFromVk(params.Output.VK);
        if (tmp) {
            value.push(1 | 0x80);
            value.push(tmp & 0xFF);
            value.push((tmp >> 8) & 0xFF);
        }


        var tmp = HIDFromVk(params.Output.VK);
        if (tmp) {
            value.push(1 | 0x40);
            value.push(tmp & 0xFF);
            value.push((tmp >> 8) & 0xFF);
        }
        params.Input.WithModifier.forEach((vk) => {
            const dvk = DVKFromVK(vk, VirtualHe6Ultra);
            value.push(0 | 0x40);
            value.push(dvk & 0xFF);
            value.push((dvk >> 8) & 0xFF);
        })
        value[value.length] = this.getCrc(value) & 0xff;

        const keyAddr = CompxEepromAddr.KeyFunction + params.Input.KK * 4;
        const keyData = [CompxMouseKeyFunction.ShortcutKey, 0, 0];
        keyData[keyData.length] = this.getCrc(keyData);

        console.log("encodeKeyAdapter", addr, value);
        return [[addr, ...value], [keyAddr, ...keyData]];
    }

    macroKey(params: KIO): number[] {
        let cycleTimes = params.Output.Extension[0] != 1 ? 1 : params.Output.Extension[1];
        if (params.Output.Extension[0] == 0) {
            cycleTimes = 1;
        }
        if (params.Output.Extension[0] == 1) {
            cycleTimes = params.Output.Extension[1] < 250 ? params.Output.Extension[1] : 250;
        }
        if (params.Output.Extension[0] == 2) {
            cycleTimes = 253
        }
        if (params.Output.Extension[0] == 3) {
            cycleTimes = 254
        }

        const param = (params.Input.KK << 8) + cycleTimes;
        const addr = CompxEepromAddr.KeyFunction + params.Input.KK * 4;
        const data = [CompxMouseKeyFunction.Macro, (param >> 8) & 0xFF, param & 0xFF, 0];
        const crc = this.getCrc(data)
        data[data.length - 1] = crc & 0xff;
        return [addr, ...data];
    }

    macroData(kk: KK, data: Record[], index: number): number[][] {
        var name = "macro" + index;
        var nameArray = this.stringToUTF8(name);

        var value = Array(33 + data.length * 5).fill(0xFF);
        value[0] = nameArray.length;
        for (let i = 0; i < nameArray.length; i++) {
            value[i + 1] = nameArray[i];
        }

        value[31] = data.length;
        var tmp = [];
        for (let i = 0; i < data.length; i++) {
            var status = data[i].Press ? 2 : 1;
            const [type, setVK] = this.getVk(data[i].Key)

            tmp.push((status << 6) + type);
            tmp.push(setVK & 0xFF);
            tmp.push(setVK >> 8);
            tmp.push(data[i].Delay >> 8);
            tmp.push(data[i].Delay & 0xFF);

            // console.log(tmp);
        }

        tmp.push(0);
        console.log(this.getCrc(tmp), data.length)
        tmp[tmp.length - 1] = (this.getCrc(tmp) - data.length) & 0xFF;

        for (var i = 0; i < tmp.length; i++) {
            value[32 + i] = tmp[i];
        }

        var addr = CompxEepromAddr.Macro + kk * 0x180;

        console.log("macroData", addr, value);
        return [[addr, ...value]];
    }

    setDpiColor(index: number, color: number[]) {
        let addr = CompxEepromAddr.DPIColor + index * 4;
        let value = [color[0], color[1], color[2], 0x00];
        value[3] = this.getCrc(value) & 0xFF;
        return [addr, ...value];
    }

    setDpiValue(index: number, value: number) {
        var addr = CompxEepromAddr.DPIValue + index * 4;
        var data = Array(4).fill(0x00);
        const dpiEx = 0
        let val = (value / 50) - 1;
        data[0] = val;
        data[1] = val;
        var high = (val) >> 8;
        data[2] = (high << 2) | (high << 6);
        data[2] |= dpiEx;
        data[3] = this.getCrc(data) & 0xFF;
        return [addr, ...data];
    }

    setReportValue(value: number) {
        let reportRate = 1;
        reportRate = value <= 1000 ? reportRate = 1000 / value : value / 2000 * 0x10;
        return [CompxEepromAddr.ReportRate, reportRate];
    }

    setDpiLightBrightness(index: number) {
        let brightnessList = [0x10, 0x1E, 0x3C, 0x5A, 0x80, 0x96, 0xB4, 0xD2, 0xE6, 0xFF]
        return brightnessList[index - 1];
    }

    private stringToUTF8(string: string) {
        const encoder = new TextEncoder();
        return encoder.encode(string);
    }

    private vkType(vk: VK): CompxHidType {
        const vkControlKeys: number[] = [0xa0, 0xa1, 0xa2, 0xa3, 0xa4, 0xa5, 0x5b, 0x5C];
        if (vkControlKeys.includes(vk)) {
            return CompxHidType.ControlKey;
        }
        return CompxHidType.NormalKey;
    }

    private getVk(key: VK) {
        let setVK: VK;
        const type = this.vkType(key)
        if (type == CompxHidType.ControlKey) {
            const dvk = DVKFromVK(key, VirtualHe6Ultra)
            const [_, vk] = this.splitDVK(dvk);
            setVK = vk as VK
        } else {
            const hid = HIDFromVk(key)
            if (hid == undefined) {
                throw new Error("hid not found:" + key);
            }
            setVK = hid
        }
        return [type, setVK]
    }


    private splitDVK(vk: VK) {
        return [(vk >> 16) & 0xFFFF, vk & 0xFFFF]
    }

    getCrc(value: number[]): number {
        var crc = 0;
        for (var i = 0; i < value.length - 1; i++) {
            crc += value[i];
        }
        crc = (crc & 0xFF);
        crc = 0x55 - crc;
        //console.log("getCrc", value, value.length, crc);
        return crc;
    }

}
export const he6UltraData = new he6Ultra();

const enum CompxHidType {
    ControlKey = 0, //控制键：ctrl，shift，win，alt
    NormalKey = 1, //普通键
    MediaKey = 2, //多媒体键
    PowerKey = 3, //电源键
    MouseKey = 4, //鼠标按键：0x0100左键，0x0200右键，0x0400中键，0x0800后退键，0x1000前进键
    XYCursor = 5 //XY光标
}

export const CompxCommand = {
    EncryptionData: 1,//下传加密沟通数据
    PCDriverStatus: 2,//下传驱动状态的命令（驱动是否处于窗口激活状态）
    DeviceOnLine: 3,//获取无线鼠标是否在线
    BatteryLevel: 4, //获取电池电量
    DongleEnterPair: 5,//设置无线Dongle进入配对状态
    GetPairState: 6,//获取无线Dongle配对结果
    WriteFlashData: 7,//设置eeprom内容
    ReadFlashData: 8,//获取eeprom内容
    ClearSetting: 9,//恢复出厂设置
    StatusChanged: 0x0A,//上报鼠标某些状态改变，如DPI等
    SetDeviceVidPid: 0x0B,//设置Dongle的USB VID/PID
    SetDeviceDescriptorString: 0x0C,//设置Dongle的USB设备描述字符串
    EnterUsbUpdateMode: 0x0D,//进入USB升级模式
    GetCurrentConfig: 0x0E,//获取当前配置
    SetCurrentConfig: 0x0F,//设置当前配置
    ReadCIDMID: 0x10,//获取鼠标CID/mid
    EnterMTKMode: 0x11,//设置无线Dongle进入EMI/MTK测试模式
    ReadVersionID: 0x12,//获取鼠标版本号

    Set4KDongleRGB: 0x14,//设置4K dongle RGB灯模式,dongle上有个rgb灯（不是在鼠标上）
    Get4KDongleRGBValue: 0x15,//获取4K dongle RGB灯模式
    SetLongRangeMode: 0x16,//设置远距离模式
    GetLongRangeMode: 0x17,//获取远距离模式

    GetDongleVersion: 0x1D,//获取dongle版本

    MusicColorful: 0xB0,//音乐律动全彩
    MusicSingleColor: 0xB1,//音乐律动全键单色

    WriteKBCIdMID: 0xF0,//读取cid mid,cx53710专用
    ReadKBCIdMID: 0xF1,//读取cid mid,cx53710专用
}


//鼠标EEPROM起始地址
export const CompxEepromAddr = {
    ReportRate: 0x00,//报告率
    maxDpiStage: 0x02,//最大DPI档位
    CurrentDPI: 0x04,//当前DPI档位
    LOD: 0x0A,//LOD高度
    DPIValue: 0x0C,//第一档DPI值
    DPIColor: 0x2C,//第一档DPI颜色
    DPIEffectMode: 0x4C,//DPI灯效
    DPIEffectBrightness: 0x4E,//DPI灯效亮度
    DPIEffectSpeed: 0x50,//DPI灯效亮度
    DPIEffectState: 0x52,//DPI灯效亮度
    Light: 0xA0,//装饰灯
    DebounceTime: 0xA9,//按钮消抖
    MotionSync: 0xAB,
    SleepTime: 0xAD,//休眠时间
    Angle: 0xAF,
    Ripple: 0xB1,
    MovingOffLight: 0xB3,
    PerformanceState: 0xB5,
    Performance: 0xB7,
    SensorMode: 0xB9,
    KeyFunction: 0x60,
    ShortcutKey: 0x0100,
    Macro: 0x0300,
}

//鼠标按键功能
export const CompxMouseKeyFunction = {
    Disable: 0x00,
    MouseKey: 0x01,
    //LeftKey: 0x0100,
    DPISwitch: 0x02,
    LeftRightRoll: 0x03,
    FireKey: 0x04,
    ShortcutKey: 0x05,
    Macro: 0x06,
    ReportRateSwitch: 0x07,
    LightSwitch: 0x08,
    ProfileSwitch: 0x09,
    DPILock: 0x0A,
    UpDownRoll: 0x0B,
    Media: 0x03ED,
}

export interface Battery {
    Level: number;
    Charging: boolean;
    Voltage: number;
}

class He6UltraPower {

    // private isCharging = false;
    private isBatVol = false;
    private lowBattery = false;
    private SupChangeBat = false;
    private factLevel = 0;

    private fullBatteryCount = 0;

    // private level1TimerID: null | NodeJS.Timeout = null;
    // private level2TimerID: null | NodeJS.Timeout = null;

    // private level1TimeEnable = false;
    // private level2TimeEnable = false;

    private displayLevel = 0;

    private batteryOptimizeInit = false;

    batteryHandleInit(battery: Battery) {
        // this.isCharging = battery.Charging;
        this.isBatVol = battery.Voltage > 0;

        var lastLevel = 0;
        // var currentTime = Math.floor((new Date()).getTime() / 1000);
        var sec = 2000;

        if (this.isBatVol) {
            this.factLevel = this.voltageToLevel(battery.Voltage, battery.Charging);
        }
        // console.log("current time:", currentTime, this.displayLevel, lastLevel, this.factLevel, sec);
        this.displayLevel = this.calculationBattery(lastLevel, this.factLevel, sec);
        // if (this.level2TimerID == null) {
        //     this.level2TimerID = setInterval(this.level2TimerTick, 60000);
        // }

        // if (this.level1TimerID == null) {
        //     this.level1TimerID = setInterval(this.level1TimerTick, 10000);
        // }

        // if (this.displayLevel > 95 && this.isCharging) {
        //     this.level2TimeEnable = false;
        // }
        // else {
        //     this.level1TimeEnable = true;
        // }
    }

    // private level1TimerTick() {
    //     if (this.level1TimeEnable) {
    //         if (this.isCharging) {
    //             if (this.factLevel > this.displayLevel) {
    //                 if (this.factLevel < 100) {
    //                     if (this.factLevel - 10 > this.displayLevel) {
    //                         this.displayLevel++;
    //                     }

    //                     if (this.displayLevel >= 85) {
    //                         this.level1TimeEnable = false;
    //                         this.level2TimeEnable = true;
    //                     }
    //                 }
    //             }
    //         }
    //         else {
    //             if (this.factLevel < this.displayLevel) {
    //                 if (this.displayLevel > 0) {
    //                     this.displayLevel--;
    //                 }
    //             }
    //         }
    //     }
    // }

    // private level2TimerTick() {
    //     if (this.level2TimeEnable) {
    //         if (this.displayLevel < 99 && this.isCharging) {
    //             this.displayLevel++;
    //         }

    //         if (this.displayLevel > 100)
    //             this.displayLevel = 100;
    //     }
    // }

    setDisplayLevel(power: number, voltage: number, charging: boolean) {
        if (this.batteryOptimizeInit == false) {
            const battery = {
                Level: power,
                Charging: charging,
                Voltage: voltage
            }
            this.batteryHandleInit(battery);
            this.batteryOptimizeInit = true;
        }

        var level = 0;

        if (this.isBatVol) {
            level = this.factLevel = this.voltageToLevel(voltage, charging);
        } else {
            level = this.factLevel = level;
        }

        const isCharging = charging;

        // if (this.displayLevel >= 85 && level >= 95 && isCharging) {
        //     if (this.level1TimeEnable) {
        //         this.level1TimeEnable = false;
        //     }

        //     if (this.level2TimeEnable == false) {
        //         this.level2TimeEnable = true;
        //     }
        // }
        // else {
        //     if (this.level1TimeEnable == false) {
        //         this.level1TimeEnable = true;
        //     }

        //     if (this.level2TimeEnable) {
        //         this.level2TimeEnable = false;
        //     }
        // }

        // console.log("setDisplayLevel", this.isBatVol, level, this.displayLevel, this.level1TimeEnable, this.level2TimeEnable)

        if (isCharging == false) {
            this.fullBatteryCount = 0;

            if (power == 0)
                this.displayLevel = 0;

            // console.log("charging false", this.displayLevel, this.factLevel);
            if (this.displayLevel < 15) {

            }
            else {
                if (power <= 15) {
                    if (this.lowBattery == false) {
                        this.lowBattery = true;

                        this.displayLevel = 15;
                    }
                }
            }

            if (this.SupChangeBat) {
                if (level > this.displayLevel) {
                    if (level - this.displayLevel >= 30) {
                        this.displayLevel = level;
                    }
                }
                else {
                    if (this.displayLevel - level >= 30) {
                        this.displayLevel = level;
                    }
                }
            }
        }
        else {
            this.lowBattery = false;

            if (power == 100) {
                if (this.fullBatteryCount < 10) {
                    this.fullBatteryCount++;
                }

                if (this.fullBatteryCount == 8) {
                    this.displayLevel = 100;
                }
            } else {
                this.fullBatteryCount = 0;
            }
        }
        return this.displayLevel;
    }

    private voltages = [3050, 3420, 3480, 3540, 3600, 3660, 3720, 3760, 3800, 3840,
        3880, 3920, 3940, 3960, 3980, 4000, 4020, 4040, 4060, 4080, 4110];
    private voltageToLevel(voltage: number, charging: boolean) {
        var level = 0;
        var interval = 0;
        var index = -1;

        if (voltage > this.voltages[this.voltages.length - 1]) {
            if (charging) {
                level = 99;
            }
            else
                level = 100;
        }
        else {
            for (var i = 0; i < this.voltages.length; i++) {
                if (voltage < this.voltages[i]) {
                    index = i;
                    break;
                }
            }

            if (index != -1) {
                if (index == 0) {
                    level = 0;
                }
                else {
                    interval = (this.voltages[index] - this.voltages[index - 1]) / 5;
                    level = (voltage - this.voltages[index - 1]) / interval + (index - 1) * 5;
                }

                if (level == 0 || level == 15) {
                    //如果是0或者15需要等鼠标下发之后才能同步，计算出来15或0需要手动+1
                    level++;
                }
            }
        }
        level = Math.round(level);
        // console.log("voltageToLevel:", voltage, level);
        return level;
    }


    private calculationBattery(lastLevel: number, factLevel: number, sec: number) {
        var level = 0;
        var theoryMaxValue = 0;
        var theoryMinValue = 0;

        if (sec > 1800) {
            level = factLevel;
        }
        else if (sec < 60) {
            level = lastLevel;
        }
        else {
            theoryMaxValue = 0.028 * sec;
            theoryMaxValue = theoryMaxValue + lastLevel > 100 ? 100 : theoryMaxValue + lastLevel;
            theoryMinValue = 0.014 * sec;
            if (theoryMinValue > lastLevel) {
                theoryMinValue = 0;
            }
            else
                theoryMinValue = lastLevel - theoryMinValue < 0 ? 0 : lastLevel - theoryMinValue;

            if (factLevel > theoryMaxValue) {
                level = theoryMaxValue;
            }
            else if (factLevel < theoryMinValue) {
                level = theoryMinValue;
            }
            else
                level = lastLevel;
        }

        return level;
    }
}

export const he6UltraPower = new He6UltraPower();